export const PROTRACKS_PUBLIC_PATH = '/protracks-public'
